 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-dashboard":"admin-dashboard","admin-orders-list":"admin-orders-list","admin-products-list":"admin-products-list","admin-sellers-details":"admin-sellers-details","admin-sellers-list":"admin-sellers-list","admin-suppliers-details":"admin-suppliers-details","admin-suppliers-list":"admin-suppliers-list","auth-login":"auth-login","auth-reset-password":"auth-reset-password","home":"home","seller-catalog":"seller-catalog","seller-dashboard":"seller-dashboard","seller-list-orders":"seller-list-orders","seller-list-products":"seller-list-products","seller-list-sales":"seller-list-sales","seller-list-stores":"seller-list-stores","seller-register":"seller-register","seller-setup":"seller-setup","seller-shop":"seller-shop","seller-store-products":"seller-store-products","seller-view-product":"seller-view-product","supplier-create-product~supplier-edit-product":"supplier-create-product~supplier-edit-product","supplier-create-product":"supplier-create-product","supplier-edit-product":"supplier-edit-product","supplier-dashboard":"supplier-dashboard","supplier-list-orders":"supplier-list-orders","supplier-list-products":"supplier-list-products","supplier-list-sales":"supplier-list-sales","supplier-register":"supplier-register","supplier-sellers-list":"supplier-sellers-list","supplier-setup":"supplier-setup"}[chunkId]||chunkId) + "." + {"admin-dashboard":"3adebf08","admin-orders-list":"b690fa8b","admin-products-list":"fa49fcde","admin-sellers-details":"8d110d84","admin-sellers-list":"75aabdce","admin-suppliers-details":"bb5f0ae8","admin-suppliers-list":"c4a116b8","auth-login":"69c427c5","auth-reset-password":"ab832ec7","home":"b71c11fb","seller-catalog":"fdfe0bb4","seller-dashboard":"a98e6324","seller-list-orders":"4d408e78","seller-list-products":"a4177879","seller-list-sales":"46c7e7ef","seller-list-stores":"b0610ecd","seller-register":"34d85b9a","seller-setup":"f1bbcd39","seller-shop":"28239a24","seller-store-products":"7a7628e1","seller-view-product":"fd59dc7b","supplier-create-product~supplier-edit-product":"858a7604","supplier-create-product":"2c1c422d","supplier-edit-product":"3218b292","supplier-dashboard":"bd6c7489","supplier-list-orders":"ae6ab52d","supplier-list-products":"2d64306f","supplier-list-sales":"6200c96e","supplier-register":"9a317f69","supplier-sellers-list":"6a6f5f45","supplier-setup":"ca75ce03"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-dashboard":1,"admin-orders-list":1,"admin-products-list":1,"admin-sellers-details":1,"admin-sellers-list":1,"admin-suppliers-details":1,"admin-suppliers-list":1,"home":1,"seller-catalog":1,"seller-dashboard":1,"seller-list-orders":1,"seller-list-products":1,"seller-list-sales":1,"seller-list-stores":1,"seller-register":1,"seller-shop":1,"seller-store-products":1,"seller-view-product":1,"supplier-create-product~supplier-edit-product":1,"supplier-create-product":1,"supplier-edit-product":1,"supplier-dashboard":1,"supplier-list-orders":1,"supplier-list-products":1,"supplier-list-sales":1,"supplier-sellers-list":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-dashboard":"admin-dashboard","admin-orders-list":"admin-orders-list","admin-products-list":"admin-products-list","admin-sellers-details":"admin-sellers-details","admin-sellers-list":"admin-sellers-list","admin-suppliers-details":"admin-suppliers-details","admin-suppliers-list":"admin-suppliers-list","auth-login":"auth-login","auth-reset-password":"auth-reset-password","home":"home","seller-catalog":"seller-catalog","seller-dashboard":"seller-dashboard","seller-list-orders":"seller-list-orders","seller-list-products":"seller-list-products","seller-list-sales":"seller-list-sales","seller-list-stores":"seller-list-stores","seller-register":"seller-register","seller-setup":"seller-setup","seller-shop":"seller-shop","seller-store-products":"seller-store-products","seller-view-product":"seller-view-product","supplier-create-product~supplier-edit-product":"supplier-create-product~supplier-edit-product","supplier-create-product":"supplier-create-product","supplier-edit-product":"supplier-edit-product","supplier-dashboard":"supplier-dashboard","supplier-list-orders":"supplier-list-orders","supplier-list-products":"supplier-list-products","supplier-list-sales":"supplier-list-sales","supplier-register":"supplier-register","supplier-sellers-list":"supplier-sellers-list","supplier-setup":"supplier-setup"}[chunkId]||chunkId) + "." + {"admin-dashboard":"a311c1c1","admin-orders-list":"015d07a3","admin-products-list":"beb4376a","admin-sellers-details":"ef3d67a9","admin-sellers-list":"2a09b38f","admin-suppliers-details":"ef3d67a9","admin-suppliers-list":"a9169822","auth-login":"31d6cfe0","auth-reset-password":"31d6cfe0","home":"23b25044","seller-catalog":"941d8408","seller-dashboard":"41d8d813","seller-list-orders":"7639c6b4","seller-list-products":"c83e4810","seller-list-sales":"8c166469","seller-list-stores":"7672fd70","seller-register":"165d0427","seller-setup":"31d6cfe0","seller-shop":"b1406156","seller-store-products":"53d8bbba","seller-view-product":"cbeebab5","supplier-create-product~supplier-edit-product":"dba58bba","supplier-create-product":"35b72f8c","supplier-edit-product":"85a640b4","supplier-dashboard":"a311c1c1","supplier-list-orders":"637681ab","supplier-list-products":"f83b2746","supplier-list-sales":"b46691d0","supplier-register":"31d6cfe0","supplier-sellers-list":"93621524","supplier-setup":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
